<script>
  import CarouselBase from '@/components/CarouselBase'

  import { useCarousel } from '@/composables/useCarousel'

  export default {
    components: {
      CarouselBase
    },
    props: {
      images: {
        type: Array,
        required: true
      }
    },
    setup (props) {
      const {
        hasNext,
        hasPrev,
        next,
        prev,
        slide
      } = useCarousel()

      return {
        hasNext,
        slide,
        next,
        prev,
        hasPrev
      }
    }
  }
</script>

<template>
  <div
    v-if="images && images.length"
    class="max-w-full overflow-hidden"
  >
    <div class="relative w-full">
      <CarouselBase
        :active-slide="slide"
        :items="images"
        :space-between="0"
        center-all-slides
        @slide-change="slide = $event"
        @has-next="hasNext = $event"
      >
        <div
          v-for="(image, index) in images"
          :key="index"
          class="slide"
        >
          <img
            :src="image.normal"
            alt=""
          >
        </div>
      </CarouselBase>
      <div
        v-if="images.length > 1"
        class="px-4"
      >
        <ul class="flex flex-row justify-center align-center">
          <li
            v-for="(image, index) in images"
            :key="index"
            tabindex="0"
            class="opacity-50 cursor-pointer "
            :class="{'opacity-100': slide === index}"
            @click="slide = index"
            @keydown.enter="slide = index"
            @keydown.space.prevent="slide = index"
          >
            <img
              :src="image.small"
              class="h-10 w-10"
              alt=""
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.slide {
  width: calc(100vw - 2rem);
  max-width: 500px;
  height: auto;
  padding-right: 2rem;


  @media screen and (min-width: 768px) {
      max-width: 336px;

  }
    @media screen and (min-width: 1024px) {
      max-width: 432px;

  }
  @media screen and (min-width: 1440px) {
      max-width: 640px;

  }

  img {
    width: 100%;
    height: auto;
    display: block;
    margin: 0 auto;
  }
}

</style>
